import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

const apps = [
  { name: "Microsoft Teams", color: "#6264A7" },
  { name: "Discord", color: "#5865F2" },
  { name: "Slack", color: "#4A154B" },
  { name: "Zoom", color: "#2D8CFF" },
];

export default function Apps({ lang }: Props) {
  const tr = t[lang].apps;

  return (
    <section className="section apps">
      <h2 className="section-title">{tr.title}</h2>
      <p className="section-sub">{tr.sub}</p>
      <div className="apps-grid">
        {apps.map((app) => (
          <div className="app-card" key={app.name} style={{ borderColor: app.color + "40", background: app.color + "15" }}>
            <span className="app-dot" style={{ background: app.color }}></span>
            <span className="app-name">{app.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
